<micro-select-combo #sel
              placeholder="Payment Transaction Status"
              [mode]="mode"
              [(id)]="paymentTransactionStatusId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
